export const termsAndConditionsModalMessages = {
  'Terms & Conditions': 'formforge.builder.terms_conditions.title',
  'No content, please fill out your terms and conditions from the properties panel':
    'formforge.builder.terms_conditions.no_content',
  Accept: 'formforge.builder.terms_conditions.accept_button',
} as const;

export type TermsAndConditionsModalMessageKey =
  keyof typeof termsAndConditionsModalMessages;
